const slugRewrite = (baseurl, slug, lang) => {
    const defaultLanguage = 'en/';
    let newSlug = slug;
    newSlug = newSlug.replace('home', '');
    newSlug = newSlug.replace(defaultLanguage, '')
    if(newSlug !== ""){
        newSlug = newSlug + '/'
    }
    if(lang === 'fr'){
        return (baseurl + '/' + lang + '/' + newSlug)
    }else{
        return (baseurl + '/' + newSlug)
    }
}
 
export default slugRewrite;